import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-500 mb-2" }, " Managers can view analytics, but cannot create or delete new teams. ", -1)
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-teal" }, "Invite Sent!", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyUserInviteForm = _resolveComponent("CompanyUserInviteForm")!
  const _component_ModalButton = _resolveComponent("ModalButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ModalButton, null, {
      button: _withCtx(() => [
        _createTextVNode("Invite new user")
      ]),
      modalTitle: _withCtx(() => [
        _createTextVNode("Invite a new user to help manage your team")
      ]),
      modalContent: _withCtx(() => [
        _hoisted_1,
        (_ctx.hideForm)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (!_ctx.hideForm)
            ? (_openBlock(), _createBlock(_component_CompanyUserInviteForm, {
                key: 0,
                onInvited: _ctx.inviteSent
              }, null, 8, ["onInvited"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}